import { Injectable } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor() {}

  convertToDatepickerFormat(date: Date, duration: number = 0): NgbDateStruct {
    const newDate: Date = new Date(date);
    newDate.setDate(newDate.getDate() + duration);

    return {
      day: newDate.getDate(),
      month: newDate.getMonth() + 1,
      year: newDate.getFullYear()
    };
  }

  convertStringToDatepickerFormat(dateString: string): NgbDateStruct {
    const dateArray: string[] = dateString.split('/'); // DD/MM/YYYY
    return {
      day: parseInt(dateArray[0], 10),
      month: parseInt(dateArray[1], 10),
      year: parseInt(dateArray[2], 10)
    };
  }

  convertToDateFormat(date: NgbDateStruct, duration: number = 0): Date {
    const newDate: Date = new Date(date.year, date.month - 1, date.day);
    newDate.setDate(newDate.getDate() + duration);

    return newDate;
  }

  calculateDurationDatepickerFormat(startDate: NgbDateStruct, endDate: NgbDateStruct): number {
    if (!isEmpty(startDate) && !isEmpty(endDate)) {
      const fromDate: number = new Date(startDate.year, startDate.month - 1, startDate.day).getTime();
      const toDate: number = new Date(endDate.year, endDate.month - 1, endDate.day).getTime();
      const delta: number = Math.abs(toDate - fromDate) / 1000;
      const days: number = Math.floor(delta / 86400);

      return days + 1;
    }
    return null;
  }

  calculateDateNextYear(startDate: NgbDateStruct): NgbDateStruct {
    const startDateinDateFormat: Date = this.convertToDateFormat(startDate);
    const dateNextYear: dayjs.Dayjs = dayjs(startDateinDateFormat).add(1, 'year');
    const calculateDate: Date = dateNextYear.subtract(1, 'day').toDate();

    return this.convertToDatepickerFormat(calculateDate);
  }

  isAfterToday(date: NgbDateStruct): boolean {
    const convertDate: Date = this.convertToDateFormat(date);
    return dayjs(convertDate, 'day').isAfter(dayjs());
  }
}
